import { useI18n } from "vue-i18n";
import { computed } from "vue";
import { useLocalStorage } from "@vueuse/core";
import { prefixedKey, STORAGE_KEY } from "@/shared/connection/local-storage.service";

const ONBOARDING_VIDEOS = {
    ...addOnboardVideo(
        ["cookie", "Easycookie"],
        "shared.creator.help_video.title",
        "shared.creator.help_video.subtitle",
        { pl: "chtqy97cs5", en: "t4uk5djxac" }
    ),
    ...addOnboardVideo(
        ["coffee", "Easycoffee"],
        "shared.creator.help_video.title",
        "shared.creator.help_video.subtitle",
        { pl: "wjcey7l5jk", en: "ibw95it9lf" }
    ),
    ...addOnboardVideo(
        ["faq", "EasyFAQ"],
        "shared.creator.help_video.title",
        "shared.creator.help_video.subtitle",
        { pl: "z3euceg4wt", en: "n110ag9a44" }
    ),
    ...addOnboardVideo(
        ["legal", "Easylegal"],
        "shared.creator.help_video.title",
        "shared.creator.help_video.subtitle",
        { pl: "aottuclzfr", en: "zba9ppcm77" }
    ),
    ...addOnboardVideo(
        ["love", "Easylove"],
        "shared.creator.help_video.title",
        "shared.creator.help_video.subtitle",
        { pl: "vkxpdcf0a2", en: "7svd1h7bag" }
    ),
    ...addOnboardVideo(
        ["page", "Easypage"],
        "shared.creator.help_video.title",
        "shared.creator.help_video.subtitle",
        { pl: "m9h0w1phk5", en: "8400jpngil" } // todo: change links from "cart" to "page" videos when on wistia ready!
    ),
    ...addOnboardVideo(
        ["player", "Easyplayer"],
        "shared.creator.help_video.title",
        "shared.creator.help_video.subtitle",
        { pl: "t1zb7e4qwp", en: "zorpt7ducz" }
    ),
    ...addOnboardVideo(
        ["pricing", "Easyoffer"],
        "shared.creator.help_video.title",
        "shared.creator.help_video.subtitle",
        { pl: "0eovkvn9ky", en: "x59t7ib6nm" },
        "offer"
    ),
    ...addOnboardVideo(
        ["ticker", "Easyticker"],
        "shared.creator.help_video.title",
        "shared.creator.help_video.subtitle",
        { pl: "dctfk8beb2", en: "sktfjtyw65" },
        "easyticker"
    ),
    ...addOnboardVideo(
        ["timer", "Easytimer"],
        "shared.creator.help_video.title",
        "shared.creator.help_video.subtitle",
        { pl: "bq3rqn1876", en: "3tqgjg52lz" }
    ),
};

export function useOnboardingVideo(toolName = "faq") {
    const { t, locale } = useI18n();

    const localStorageClosedOnboardingVideos = useLocalStorage(
        prefixedKey(STORAGE_KEY.closeOnboardingVideos),
        []
    );

    const video = computed(() => {
        const { videoIds, title, subtitle, businessLink, businessToolName } =
            ONBOARDING_VIDEOS[toolName] || {};
        const currentLang = locale.value || "en";
        const id = videoIds?.[currentLang];
        return {
            id,
            title: t(title, { tool: businessToolName }),
            subtitle: t(subtitle, { tool: businessToolName }),
            videoLink: `https://fast.wistia.com/embed/iframe/${id}`, //https://fast.wistia.com/embed/medias/n110ag9a44
            imageLink: `https://fast.wistia.com/embed/medias/${id}/swatch`,
            actionLink: `https://www.easy.tools${currentLang === "en" ? "" : "/" + currentLang}/${businessLink}`,
            show: !localStorageClosedOnboardingVideos.value.includes(toolName),
            closeVideo: () => localStorageClosedOnboardingVideos.value.push(toolName),
        };
    });

    return { video };
}

function addOnboardVideo(
    [tool, businessToolName],
    title,
    subtitle,
    videoIds = { pl: "", en: "" },
    businessLink
) {
    return {
        [tool]: {
            title,
            subtitle,
            videoIds,
            businessLink: businessLink || tool,
            businessToolName,
        },
    };
}
